import React, { Component, useState, createRef } from "react";
import "../index.scss";
import NeutralIcon from "../icons/neutral.svg";
import CorrectIcon from "../icons/correct.svg";
import FalseIcon from "../icons/false.svg";
import bQuizIcon from "../icons/bQuiz.svg";
import InfoIcon from "../icons/info.svg";
import ActionButton from "./actionButton";

import classnames from "classnames";
import SoundEffects from "./SoundEffects";
import VideoModal from "./videoModal";

export default class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentQuestionIndex: 0,
      currentGivenAnswer: null,
      submissionBody: [],
      isNextQuestionAvailable: false,
    };
  }
  setCurrentAnswer = (answer) => {
    this.setState({ currentGivenAnswer: answer });
  };
  chooseButtonAction = () => {
    if (
      this.state.submissionBody.length ===
        this.props.data.question_answer.length &&
      this.state.currentQuestionIndex === this.state.submissionBody.length - 1
    ) {
      this.props.callBack(this.state.submissionBody);
      return;
    }

    if (this.state.isNextQuestionAvailable) this.nextQuestion();
    else this.checkAnswer();
  };
  checkAnswer = () => {
    const currentCorrectAnswer =
      this.props.data.question_answer[this.state.currentQuestionIndex]
        .correct_answer;
    const isCorrect =
      this.state.currentGivenAnswer.answer === currentCorrectAnswer;

    this.setState((prevState) => ({
      submissionBody: [
        ...prevState.submissionBody,
        { ...prevState.currentGivenAnswer, isCorrect: isCorrect },
      ],
      isNextQuestionAvailable: true,
      currentGivenAnswer: {
        ...prevState.currentGivenAnswer,
        isCorrect: isCorrect,
      },
    }));

    isCorrect ? SoundEffects.playCorrect() : SoundEffects.playWrong();
  };
  nextQuestion = () => {
    this.setState((prevState) => ({
      currentGivenAnswer: null,
      currentQuestionIndex: prevState.currentQuestionIndex + 1,
      isNextQuestionAvailable: false,
    }));
  };

  render() {
    const { data } = this.props;
    const { question_answer } = data;
    const currentQuestion = question_answer[this.state.currentQuestionIndex];
    const {
      currentGivenAnswer,
      isNextQuestionAvailable,
      currentQuestionIndex,
      submissionBody,
    } = this.state;
    return (
      <div className="quiz-container">
        <div className="status-indicator-container">
          <img src={bQuizIcon} />
          <div className="indicator-container">
            {question_answer.map((i, _index) => (
              <div
                key={i}
                onClick={() => {
                  if (_index > submissionBody.length) return;
                  else
                    this.setState({
                      currentQuestionIndex: _index,
                      currentGivenAnswer: submissionBody[_index],
                      isNextQuestionAvailable: _index < submissionBody.length,
                    });
                }}
                className={classnames({
                  current:
                    !submissionBody[_index] && _index === currentQuestionIndex,
                  correct: submissionBody[_index]?.isCorrect === true,
                  false: submissionBody[_index]?.isCorrect === false,
                })}
              ></div>
            ))}
          </div>
        </div>

        <div className="question">{currentQuestion.question_body}</div>

        <div className="answer-options-container">
          {currentQuestion?.answers?.map((i) => (
            <button
              key={i}
              className={classnames("answer-option", {
                "not-checked":
                  i === currentGivenAnswer?.answer &&
                  currentGivenAnswer?.isCorrect === "not-checked",
                correct:
                  i === currentGivenAnswer?.answer &&
                  currentGivenAnswer?.isCorrect === true,
                false:
                  i === currentGivenAnswer?.answer &&
                  currentGivenAnswer?.isCorrect === false,
                correct:
                  currentGivenAnswer &&
                  i === currentQuestion.correct_answer &&
                  currentGivenAnswer?.isCorrect !== "not-checked",
              })}
              onClick={() => {
                if (isNextQuestionAvailable) return;
                else
                  this.setCurrentAnswer({
                    question: currentQuestion.question_body,
                    answer: i,
                    isCorrect: "not-checked",
                  });
              }}
            >
              <p>{i}</p>
              <span>
                <img
                  src={
                    currentGivenAnswer?.answer === i &&
                    currentGivenAnswer?.isCorrect === "not-checked"
                      ? NeutralIcon
                      : i === currentGivenAnswer?.answer &&
                        currentGivenAnswer?.isCorrect === true
                      ? CorrectIcon
                      : i === currentGivenAnswer?.answer &&
                        currentGivenAnswer?.isCorrect === false
                      ? FalseIcon
                      : currentGivenAnswer &&
                        i === currentQuestion.correct_answer &&
                        currentGivenAnswer?.isCorrect !== "not-checked"
                      ? CorrectIcon
                      : null
                  }
                />
              </span>
            </button>
          ))}
        </div>
        <div className="guide">
          <img src={InfoIcon} />
          <p>ভিডিওটি পুনরায় দেখতে “আবার দেখে নিন” বাটনটি চাপুন</p>
        </div>
        {data.video_link && <VideoModal video_link={data.video_link} />}
        <ActionButton
          title={
            this.state.isNextQuestionAvailable
              ? submissionBody.length === question_answer.length &&
                currentQuestionIndex === submissionBody.length - 1
                ? "কুইজের ফলাফল দেখে নিন"
                : "পরবর্তী প্রশ্ন দেখুন"
              : "উত্তর যাচাই করুন"
          }
          onClick={this.chooseButtonAction}
          disabled={!currentGivenAnswer}
          loading={this.props.checking}
        />
      </div>
    );
  }
}
